import pub from './../public';
const type = pub.getLang();

const language = {
  'zh-hk': {
    areaDimension: '呎',
    whatsAppShare1: ['業主', '您好，我對您在House730的放盤有興趣', '您好，我對您在House730的租盤有興趣', '售', '月租', '面積', '想查詢更多：'],
    plane: '平面圖',
    saleFormUnpaid: '未補',
    saleFormPaid: '已補',
    myFavourites: '樓盤收藏',
    subscribe:'樓盤訂閱',
    residential: '住宅',
    offices: '工商',
    delColTit: '確定清除已收藏樓盤？',
    clear: '清空',
    find: '共找到',
    agencyPage: '個人專頁',
    copySuccessText: '已成功複製連結',
    properties: '個樓盤',
    wuEst: '個屋苑',
    noInfo: '暫時未有符合搜尋條件的樓盤',
    browseHistory: '瀏覽記錄',
    noMore: '沒有更多了',
    loading: '加載中',
    messageTit: '確定清除瀏覽記錄？',
    confirmButtonText: '確定',
    cancelButtonText: '取消',
    sale:'售盤',
    esSale: '售盤',
    rent: '租盤',
    newSale:'一手新盤',
    estate:'屋苑',
    estateActual:'實',
    vrFind: 'VR睇樓',
    aerial: '航拍VR',
    listBuy: '售',
    listRent: '租',
    monDeal:'月成交',
    dealSaleCountUnit: '宗',
    chi: '呎',
    collectionNotes: '收藏備註',
    shortRent: '短租',
    sublet: '分租',
    verifyLabel: '樓盤已驗證',
    // newPrice:'發展商還未有發出價單',
    // newSalePrice:'樓盤已開始發售',
    isnewPrice:'張價單',
    chi:'呎',
    landlord: '業主自讓盤',
    Landlord: '業主盤',
    agency: '代理盤',
  },
  "zh-cn": {
    areaDimension: '尺',
    whatsAppShare1: ['业主', '您好，我对您在House730的放盘有兴趣', '您好，我对您在House730的租盘有兴趣', '售', '月租', '面积', '想查询更多：'],
    plane: '平面图',
    saleFormUnpaid: '未补',
    saleFormPaid: '已补',
    myFavourites: "楼盘收藏",
    subscribe:'楼盘订阅',
    residential: "住宅",
    offices: "工商",
    delColTit: "确定清除已收藏楼盘？",
    clear: "清空",
    find: "共找到",
    agencyPage: '个人专页',
    copySuccessText: '已成功复制链接',
    properties: "个楼盘",
    wuEst: '个屋苑',
    noInfo: "暂时未有符合搜寻条件的楼盘",
    browseHistory: "浏览记录",
    noMore: "沒有更多了",
    loading: "加载中",
    messageTit: "确定清除浏览记录？",
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    sale:"售盘",
    esSale: "售盘",
    rent: "租盘",
    newSale:'一手新盘',
    estate:'屋苑',
    estateActual:'实',
    vrFind: 'VR睇楼',
    aerial: '航拍VR',
    listBuy: '售',
    listRent: '租',
    monDeal:'月成交',
    dealSaleCountUnit: '宗',
    chi: '尺',
    collectionNotes: "收藏备注",
    ShortRent: '短租',
    sublet: '分租',
    verifyLabel: '楼盘已验证',
    // newPrice:'发展商还未有发出价单',
    // newSalePrice:'楼盘已开始发售',
    isnewPrice:'张价单',
    chi:'尺',
    landlord: '业主自让盘',
    Landlord: '业主盘',
    agency: '代理盘',
  },
  "en-us": {
    areaDimension: 'sq. ft.',
    whatsAppShare1: ['Landlord', 'I am interested in your property for sale in House730', 'I am interested in your property for rent in House730.com', 'Price', 'Rent', 'Area', ' I would like to ask for more information：'],
    plane: 'Floor Plan',
    saleFormUnpaid: 'Prem. Unpaid',
    saleFormPaid: 'Prem. Paid',
    myFavourites: "Bookmark",
    subscribe:'Property Subscription',
    residential: "Residential",
    offices: "Offices",
    delColTit: "Clear bookmarked property?",
    clear: "Empty",
    find: "",
    agencyPage: 'Agency Page',
    copySuccessText: 'Copied to Clipboard',
    properties: " properties found",
    wuEst: ' estates found',
    noInfo: "No matched listing property found temporarily",
    browseHistory: "Browsing History",
    noMore: "No More",
    loading: "loading",
    messageTit: "Clear browsing history?",
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    sale:"Sale",
    esSale: "Sale",
    rent: "Rent",
    newSale:'New',
    estate:'Estate',
    estateActual:'SA',
    vrFind: 'VR',
    aerial: 'Aerial VR',
    listBuy: 'Sale',
    listRent: 'Rent',
    monDeal:'Transaction Volume in',
    dealSaleCountUnit:'宗',
    chi: '呎',
    collectionNotes: "Bookmark Property Notes",
    ShortRent: 'Short-term',
    sublet: 'Share',
    verifyLabel: 'Verified',
    chi:'sq.ft.',
    // newPrice:'No price list yet',
    // newSalePrice:'The development is for sale now',
    isnewPrice:' Price Lists',
    landlord: 'Landlord',
    Landlord: 'Landlord',
    agency: 'Agency',
  },
}
export default language[type]